import classNames from 'classnames';
import { forwardRef } from 'react';
import styles from './styles.module.scss';

export interface IFloatingOverlayProps {
  className?: string;
  title: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  children: React.ReactNode;
}

const FloatingOverlay = forwardRef<HTMLDivElement, IFloatingOverlayProps>(
  ({ className, title, leftIcon, rightIcon, children }, ref) => {
    return (
      <div ref={ref} className={classNames(styles.container, className)} data-testid='floating-overlay'>
        <header>
          {leftIcon}
          <strong>{title}</strong>
          {rightIcon}
        </header>
        <div className={styles.content}>
          <div role='menu'>{children}</div>
        </div>
      </div>
    );
  },
);

FloatingOverlay.displayName = 'FloatingOverlay';

export default FloatingOverlay;
